module.exports = __webpack_public_path__ + "img/activity-nutrition-main.3e55965e.png";